const colors = {
  background: '#000000',
  // backgroundDark: '#f0e6f6',
  backgroundDark: '#000',

  // primary: '#7c37ad',
  primary: 'white',
  // primaryLight: '#ae66df',
  primaryLight: '#00B1FF',
  primaryDark: '#222222',

  // secondary: '#ff4081',
  secondary: '#00B1FF',
  // secondaryLight: '#ff79b0',
  secondaryLight: '#00B1FF',
  // secondaryDark: '#c60055',
  secondaryDark: '#00B1FF',
  

};

module.exports = {
  colors,
  fonts: {
    sans: '\'Work Sans\', sans-serif',
    mono: '\'Work Sans\', sans-serif',
  },
  breakpoints: [ '32em', '48em', '64em' ]
};
